import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { FaCalendarDays, FaTag } from "react-icons/fa6";
import InsightsDashboardGraphic from "../images/graphics/insights-dashboard.svg";
import { buildApiUrl, buildAssetUrl } from "../utils/api";

function BlogDetailMarketplace() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(buildApiUrl(`/api/blogs/${id}`));
        setBlog(response.data);
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
    };

    fetchBlog();
  }, [id]);

  if (!blog) {
    return <div className="page-loader">Loading article...</div>;
  }

  const imagePath = Array.isArray(blog.image) ? blog.image[0] : blog.image;

  return (
    <>
      <Helmet>
        <title>{blog.title} | 3PL Search</title>
      </Helmet>

      <div className="blog-detail-page">
        <section className="content-section">
          <div className="container">
            <article className="surface-card article-shell">
              <span className="eyebrow-badge">Insight article</span>
              <h1>{blog.title}</h1>
              <div className="market-card-meta">
                <p><FaCalendarDays /> {new Date(blog.date).toLocaleDateString()}</p>
                <p><FaTag /> {blog.tags}</p>
              </div>
              <img
                className="article-image"
                src={imagePath ? buildAssetUrl(imagePath) : InsightsDashboardGraphic}
                alt={blog.title}
              />
              <div className="article-content">
                <p><strong>Description:</strong> {blog.description}</p>
                <p><strong>Summary:</strong> {blog.summary}</p>
              </div>
            </article>
          </div>
        </section>
      </div>
    </>
  );
}

export default BlogDetailMarketplace;
